import "./animatedCheck.css"

export default function AnimatedCheck() {
  return (
    <svg id="my-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290 290">
    <circle className="animated-circle"  cx="145" cy="145" r="124.67"/>
    <polyline className="animated-checkmark" points="88.75 148.26 124.09 183.6 201.37 106.32"/>
    </svg>
  );
}
